import React from 'react';
import { useNavigate } from 'react-router-dom';

import { changeDateFormat } from '@utils/Util';

const QuotesCard = ({ details }) => {
	const navigate = useNavigate();
	const redirectToPage = () => {
		if (details?.quoteApprovalStatus === 'APPROVED') return navigate(`/costing/${details.id}`);
		return navigate(`/quote/request/${details.id}`);
	};
	return (
		<div className="sample-single-item" onClick={() => redirectToPage()}>
			<div className="container-fluid pl-0">
				<div className="row">
					<div className="col-sm-12 col-md-5 col-lg-5 col-xl-4 one-sixth">
						<div className="d-flex align-items-center img-and-content">
							<div className="product-img-container">
								<div className="prev-img">
									{details?.productFeatureImageList[0] ? (
										<img src={details?.productFeatureImageList[0]} alt="" />
									) : (
										<img
											src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
											alt=""
										/>
									)}
								</div>
								<div className="prev-img-thumb">
									<div className="single-first">
										{details?.productFeatureImageList[1] ? (
											<img src={details?.productFeatureImageList[1]} alt="" />
										) : (
											<img
												src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
												alt=""
											/>
										)}
									</div>
									<div className="single-second">
										{details?.productFeatureImageList[2] ? (
											<img src={details?.productFeatureImageList[2]} alt="" />
										) : (
											<img
												src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
												alt=""
											/>
										)}
									</div>
								</div>
							</div>
							<div className="contents pl-3">
								<p className="medium-14 gray_dark_01 mb-1">
									{details?.title || details?.collectionName}
								</p>
								<ul className="common-list-component mb-2">
									<li>{details?.referenceNumber}</li>
									<li>{details?.requestedBy} </li>
								</ul>
								<span className="brand-common-design">{details?.brandName}</span>
							</div>
						</div>
					</div>

					<div className="col-sm-8 col-md-5 col-lg-5  col-xl-4 one-sixth request-info-date-details">
						<div className="d-flex justify-content-center after-boder">
							<div className="mr-4 req-costing-info">
								<p className="regular-12 gray_dark_02">
									<span className="info-label">Design</span>
									<span className="gray_dark_01 ml-2">{details?.noOfDesign}</span>
								</p>
								<p className="regular-12 gray_dark_02">
									<span className="info-label">Qty</span>
									<span className="gray_dark_01 ml-2">{details?.totalQuantity}</span>
								</p>
								<p className="regular-12 gray_dark_02">
									<span className="info-label">Price</span>
									<span className="gray_dark_01 ml-2">
										${details?.totalPrice.toFixed(2)}
									</span>
								</p>
							</div>
							<div className="expected-dates ml-1">
								{details?.requestedDate && (
									<p className="regular-12 gray_dark_02">
										<span>Requested</span>
										<span className="gray_dark_01 ml-2">
											{changeDateFormat(details?.requestedDate, 'YYYY/MM/DD', 'DD MMM')}
										</span>
									</p>
								)}
								{details?.requiredDate && (
									<p className="regular-12 gray_dark_02">
										<span>Required</span>
										<span className="gray_dark_01 ml-2">
											{changeDateFormat(details?.requiredDate, 'YYYY/MM/DD', 'DD MMM')}
										</span>
									</p>
								)}
								{details?.estimatedOrderDeliveryDate && (
									<p className="regular-12 gray_dark_02">
										<span>Order ETD</span>
										<span className="gray_dark_01 ml-2">
											{changeDateFormat(
												details?.estimatedOrderDeliveryDate,
												'YYYY/MM/DD',
												'DD MMM'
											)}
										</span>
									</p>
								)}
							</div>
						</div>
					</div>

					<div className="col-sm-4 col-md-2 col-lg-2 col-xl-4 one-sixth">
						<div className="sample-status">
							<span className="status">Quotes</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default QuotesCard;
